/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Show_PreferencesInputs */

const en_cookies_show_preferences = /** @type {(inputs: Cookies_Show_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage preferences`)
};

const pl_cookies_show_preferences = /** @type {(inputs: Cookies_Show_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj ustawieniami`)
};

/**
* | output |
* | --- |
* | "Manage preferences" |
*
* @param {Cookies_Show_PreferencesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_show_preferences = /** @type {((inputs?: Cookies_Show_PreferencesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Show_PreferencesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_show_preferences(inputs)
	return en_cookies_show_preferences(inputs)
});